import React from "react";

const InnovationLab = () => {
    return (
        <div className="w-full text-gray-800">

            {/* HERO */}
            <section className="relative bg-gradient-to-r from-indigo-900 via-purple-900 to-blue-900 text-white py-24 px-6">
                <div className="max-w-7xl mx-auto">
                    <h1 className="text-4xl md:text-5xl font-bold mb-6">
                        Innovation Labs
                    </h1>
                    <p className="max-w-3xl text-gray-200 mb-10">
                        The Innovation Labs at Persistent leverages high-impact emerging
                        technologies to drive digital transformation, improve customer
                        experience, and unlock new business value.
                    </p>

                    {/* FEATURE BOXES */}
                    <div className="grid md:grid-cols-3 gap-6">
                        {[
                            {
                                title: "Design-led Prototyping",
                                desc:
                                    "Enhance UX with design-led, human-centered digital solutions from Persistent Digital Greenhouse.",
                            },
                            {
                                title: "Accelerated Research",
                                desc:
                                    "Fast-track R&D with Deep Tech like AI, Blockchain, Intelligent UX & Augmented Reality.",
                            },
                            {
                                title: "Innovation-as-a-Service",
                                desc:
                                    "Design & build global digital innovation labs, create POCs & customized hackathons for enterprises.",
                            },
                        ].map((item, i) => (
                            <div
                                key={i}
                                className="border border-orange-400/40 rounded-lg p-6"
                            >
                                <h3 className="font-semibold text-lg mb-3">{item.title}</h3>
                                <p className="text-sm text-gray-200">{item.desc}</p>
                            </div>
                        ))}
                    </div>

                    {/* CAPABILITIES */}
                    <div className="grid grid-cols-2 md:grid-cols-6 gap-4 mt-12 text-sm">
                        {[
                            "Blockchain",
                            "Artificial Intelligence",
                            "Intelligent UX",
                            "Cloud",
                            "Data & Analytics",
                            "Life Sciences",
                        ].map((cap) => (
                            <div
                                key={cap}
                                className="border border-orange-400/30 rounded px-4 py-2 text-center"
                            >
                                {cap}
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* RECENT INNOVATIONS */}
            <section className="bg-[#2e2b36] text-white py-20 px-6">
                <div className="max-w-7xl mx-auto">
                    <h2 className="text-2xl font-semibold mb-2">
                        Recent Innovation and Solutions
                    </h2>
                    <p className="text-gray-300 mb-10">
                        Know about our innovative offerings and how we can help your
                        enterprise!
                    </p>

                    <div className="grid md:grid-cols-3 gap-8">
                        {[
                            {
                                title: "Experience Transformation",
                                tag: "Persistent Consulting",
                                img: "/images/innovation/innovation-1.jpg",
                            },
                            {
                                title: "Life Sciences Research Collaboration",
                                tag: "Life Sciences",
                                img: "/images/innovation/innovation-2.jpg",
                            },
                            {
                                title: "Technology Advisory & Consulting",
                                tag: "Digital Strategy & Design",
                                img: "/images/innovation/innovation-3.jpg",
                            },
                            {
                                title: "Experience Design",
                                tag: "Digital Strategy & Design",
                                img: "/images/innovation/innovation-4.jpg",
                            },
                            {
                                title: "Digital Product & Platform Design",
                                tag: "Software Product Engineering",
                                img: "/images/innovation/innovation-5.jpg",
                            },
                            {
                                title: "Product & Platform Strategy",
                                tag: "Software Product Engineering",
                                img: "/images/innovation/innovation-6.jpg",
                            },
                        ].map((card, i) => (
                            <div key={i} className="bg-[#3a3746] rounded overflow-hidden">
                                <img src={card.img} alt={card.title} />
                                <div className="p-6">
                                    <p className="text-xs text-orange-400 mb-2">{card.tag}</p>
                                    <h4 className="font-semibold mb-4">{card.title}</h4>
                                    <span className="text-orange-400 text-sm">
                                        Learn more →
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* THOUGHT LEADERSHIP */}
            <section className="bg-white py-20 px-6">
                <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">
                    <img
                        src="/images/innovation/blog.jpg"
                        alt="Thought leadership"
                        className="rounded-lg"
                    />
                    <div className="bg-[#2e2b36] text-white p-10 rounded-lg">
                        <p className="text-sm text-gray-300 mb-3">Blog</p>
                        <h3 className="text-2xl font-semibold mb-6">
                            An overview of the evolution from DevOps to DataOps to XOps
                        </h3>
                        <button className="bg-white text-black px-6 py-2 rounded text-sm">
                            Read the blog
                        </button>
                    </div>
                </div>
            </section>

            {/* EVENTS */}
            <section className="bg-gray-100 py-20 px-6">
                <div className="max-w-7xl mx-auto">
                    <h2 className="text-2xl font-semibold mb-2">
                        Innovation Events
                    </h2>
                    <p className="text-gray-600 mb-10">
                        Register to join us for our virtual events or watch a replay of the
                        sessions.
                    </p>

                    <div className="grid md:grid-cols-3 gap-8">
                        {[
                            {
                                title: "Responsible AI sessions for Pune Knowledge Cluster",
                                date: "May 2021",
                                img: "/images/innovation/event-1.jpg",
                            },
                            {
                                title:
                                    "Operationalizing AI/ML: Journey of a ML Model to Production",
                                date: "May 2022",
                                img: "/images/innovation/event-2.jpg",
                            },
                            {
                                title:
                                    "Persistent’s Knowledge Graph Solutions for Enhancing Tax Research",
                                date: "May 2022",
                                img: "/images/innovation/event-3.jpg",
                            },
                        ].map((event, i) => (
                            <div key={i} className="bg-white rounded overflow-hidden shadow">
                                <img src={event.img} alt={event.title} />
                                <div className="p-6">
                                    <p className="text-xs text-orange-500 mb-2">
                                        {event.date}
                                    </p>
                                    <h4 className="font-semibold">{event.title}</h4>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CONTACT */}
            <section className="bg-white py-20 px-6">
                <div className="max-w-7xl mx-auto">
                    <h2 className="text-2xl font-semibold mb-10">Contact us</h2>
                    <form className="grid md:grid-cols-3 gap-6">
                        <input className="border p-3 rounded" placeholder="First name*" />
                        <input className="border p-3 rounded" placeholder="Last name*" />
                        <input className="border p-3 rounded" placeholder="Work email*" />
                        <input className="border p-3 rounded" placeholder="Company*" />
                        <input className="border p-3 rounded" placeholder="Job title*" />
                        <input
                            className="border p-3 rounded"
                            placeholder="Phone number (optional)"
                        />
                        <textarea
                            className="md:col-span-3 border p-3 rounded"
                            rows="4"
                            placeholder="How can we help you?"
                        />
                        <div className="md:col-span-3 flex items-center gap-2 text-sm">
                            <input type="checkbox" />
                            <span>I agree to the privacy notice</span>
                        </div>
                        <button className="bg-orange-500 text-white px-8 py-3 rounded">
                            Submit
                        </button>
                    </form>
                </div>
            </section>

        </div>
    );
};

export default InnovationLab;
